import _sfc_main from "./AITranscription.vue2.mjs";
/* empty css                      */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "conversationContainerRef", staticClass: "conversation", on: { "scroll": _setup.handleScroll } }, _vm._l(_setup.transcribedMessageList, function(group) {
    return _c("div", { key: group.startMsTs, staticClass: "conversation-group" }, [_c("div", { staticClass: "title" }, [_c("span", { staticClass: "speaker" }, [_vm._v(_vm._s(_setup.roomService.roomStore.getDisplayName(group.sender)))]), _c("span", { staticClass: "timestamp" }, [_vm._v(" " + _vm._s(_setup.formatTimestampToTime(group.startMsTs)) + " ")])]), _vm._l(group.messages, function(message, messageIndex) {
      return _c("div", { key: messageIndex, staticClass: "content" }, [_vm._v(" " + _vm._s(message.text) + " ")]);
    })], 2);
  }), 0);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "e459c8be"
);
const AITranscription = __component__.exports;
export {
  AITranscription as default
};
